if (typeof ShippingNoticeV2 !== "function") {
  class ShippingNoticeV2 extends HTMLElement {
    constructor() {
      super();
      this.form = document.querySelector("cart-form form");
      this.productAsGift = this.getAttribute("data-free-gift-product");
      this.originalProduct=this.getAttribute("data-free-gift-original-product"); 
      this.shouldDelete = this.getAttribute("data-should-delete");
      this.productListContainer= this.querySelector('.cart-notice__product-list')
      this.productListItems = this.querySelectorAll('.cart-item')
      this.productList = JSON.parse(this.dataset.productList);
      this.productListSize = this.productList.length;
      this.init();
    }

    connectedCallback() {
      this.productListItems.forEach((product,i) => {
        //remove
        product.querySelector('.remove').addEventListener("click", (e) => {
          e.preventDefault();
          if(product.classList.contains('selected-product')){
            this.removeGiftProduct();
          }
        })


        //add to cart
        product.querySelector('.atc_list_trigger').addEventListener("click", (e) => {
          if(!product.classList.contains('selected-product')){
            //call add to cart product
            this.productAsGift = this.productList[i].variants[0].id;
        this.originalProduct = this.productAsGift;
        this.form.classList.add("processing");
        const body = JSON.stringify({
          id: parseInt(this.productAsGift),
          quantity: 1,
          properties:{
            "_free_gift_product": true
          }
        });
  
          fetch(KROWN.settings.routes.cart_add_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
              body
          })
          .then(response => response.json())
          .then(response => {
              if ( response.status == 422 ) {
                  // wrong stock logic alert
                  alert = document.createElement('span');
                  alert.classList.add('alert', 'alert--error');
                  if ( typeof response.description === 'string' ) {
                      alert.innerHTML = response.description;
                  } else {
                      alert.innerHTML = response.message;
                  }
              }
              return fetch('?section_id=helper-cart');
          })
          .then(response => response.text())
          .then(text => {
  
              const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
              const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
              const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
  
              const cartItems = document.getElementById('AjaxCartForm');
              cartItems.innerHTML = cartFormInnerHTML;
              cartItems.ajaxifyCartItems();
  
              document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                  elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
              });
              document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                  elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
              });
  
              if ( alert !== null ) {
                  this.form.prepend(alert);
              } 
  
              document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                      
              const event = new Event('cart-updated');
              this.dispatchEvent(event);
  
          })
          .catch(e => {
              console.log(e);
              let alert = document.createElement('span');
              alert.classList.add('alert', 'alert--error');
              alert.textContent = KROWN.settings.locales.cart_general_error;
              this.form.prepend(alert);
          })
          .finally(() => {
              this.form.classList.remove('processing');
          });



            
          }
        })
      });
    }

    init() {
      const freeShippingThreshold = Math.round(
        Number(this.getAttribute("data-free-shipping")) *
          (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
      );
      const freeShippingProductThreshold = Math.round(
        Number(this.getAttribute("data-free-gift-product-amount")) *
          (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
      );
      const cartTotal = Number(this.getAttribute("data-cart-total"));
      const freeShippingRemaining = cartTotal - freeShippingThreshold;
      const freeShippingProductRemaining =
        cartTotal - freeShippingProductThreshold;

      let cartSliderWidth = 0;
      //add product to not prevent add product to cart
      this.productListContainer?.classList.remove('eligible');
      if (freeShippingRemaining < 0) {
        this.querySelector("[data-js-free-shipping-text]").innerHTML =
          window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace(
            "{{ remaining_amount }}",
            this._formatMoney(
              Math.abs(freeShippingRemaining),
              KROWN.settings.shop_money_format
            ).replace(" AUD", "")
          );
        cartSliderWidth = (cartTotal / freeShippingProductThreshold) * 100;
        //should delete
        //this.removeGiftProduct();
        // debugger
        // if(this.shouldDelete === null){
        //     this.getProductInCart(this.originalProduct)?.querySelector('a.remove').click();
        // }
      } else if (freeShippingProductRemaining < 0) {
        this.querySelector("[data-js-free-shipping-text]").innerHTML =
          window.KROWN.settings.locales.product_gift_remaining.replace(
            "{{ remaining_amount }}",
            this._formatMoney(
              Math.abs(freeShippingProductRemaining),
              KROWN.settings.shop_money_format
            ).replace(" AUD", "")
          );
        cartSliderWidth = (cartTotal / freeShippingProductThreshold) * 100;
        //should delete
        //this.removeGiftProduct();
        // debugger
        // if(this.shouldDelete === null){
        //     this.getProductInCart(this.originalProduct)?.querySelector('a.remove').click();
        // }
      } else {
        this.querySelector("[data-js-free-shipping-text]").innerHTML =
          window.KROWN.settings.locales.shipping_notice_eligible_for_free_product;
        cartSliderWidth = 100;
        if(this.isProductInCart(this.productList) === false && this.shouldDelete !== "false" && this.productListSize === 1){
            this.addProductToCart();
        }
        else if ( this.productListSize > 1){
            this.productListContainer?.classList.add('eligible');
            this.renderItems();
        }
        
      }
      if (this.querySelector("[data-js-free-shipping-slider]")) {
        this.querySelector(
          "[data-js-free-shipping-slider]"
        ).style.width = `${cartSliderWidth}%`;
      }
    }
    addProductToCart() {
      //for now hundle the case for only one product
      if(this.productListSize === 1){
        this.productAsGift = this.productList[0].variants[0].id;
        this.originalProduct = this.productAsGift;
        this.form.classList.add("processing");
        const body = JSON.stringify({
          id: parseInt(this.productAsGift),
          quantity: 1
        });
  
          fetch(KROWN.settings.routes.cart_add_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
              body
          })
          .then(response => response.json())
          .then(response => {
              if ( response.status == 422 ) {
                  // wrong stock logic alert
                  alert = document.createElement('span');
                  alert.classList.add('alert', 'alert--error');
                  if ( typeof response.description === 'string' ) {
                      alert.innerHTML = response.description;
                  } else {
                      alert.innerHTML = response.message;
                  }
              }
              return fetch('?section_id=helper-cart');
          })
          .then(response => response.text())
          .then(text => {
  
              const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
              const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
              const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
  
              const cartItems = document.getElementById('AjaxCartForm');
              cartItems.innerHTML = cartFormInnerHTML;
              cartItems.ajaxifyCartItems();
  
              document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                  elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
              });
              document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                  elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
              });
  
              if ( alert !== null ) {
                  this.form.prepend(alert);
              } 
  
              document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                      
              const event = new Event('cart-updated');
              this.dispatchEvent(event);
  
          })
          .catch(e => {
              console.log(e);
              let alert = document.createElement('span');
              alert.classList.add('alert', 'alert--error');
              alert.textContent = KROWN.settings.locales.cart_general_error;
              this.form.prepend(alert);
          })
          .finally(() => {
              this.form.classList.remove('processing');
          });
      }
      else if (this.productListSize > 1){
        //handle other case for multiple and display for now products for offer

      }


    }
    renderItems(){
      //search for items in cart
      
      this.productListContainer.classList.remove('have-selected-product');
      const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
      for (let i = cartItems.length - 1; i >= 0; i--) {
        this.productList.forEach((product, index) => {
          if(product.id === parseInt(cartItems[i].dataset.productId)){
            this.productListItems[index].classList.add('selected-product');
            this.productListContainer.classList.add('have-selected-product');
            this.productListItems[index].querySelector('.atc_list_trigger .button__text').textContent = "ADDED";
          }
          else{
            this.productListItems[index].classList.remove('selected-product');
            this.productListItems[index].querySelector('.atc_list_trigger .button__text').textContent = "ADD GIFT";
          }
        });
      }
    }

    removeGiftProduct() {
      const cartItemGift = document.getElementById('AjaxCartForm').querySelector('.gifted-product[data-js-cart-item]');
      if(cartItemGift){
        cartItemGift.querySelector('a.remove').click();
      }
    }

    isProductInCart(productList) {
        const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
        for (let i = 0; i < cartItems.length; i++) {
            if (productList.some(product => product.id === parseInt(cartItems[i].dataset.productId))) {
              return true;
            }
        }
        return false;
    }
    getProductInCart(productId) {
        const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
        for (let i = 0; i < cartItems.length; i++) {
            if (cartItems[i].dataset.productId === productId) {
                return cartItems[i];
            }
        }
        return null;
    }
    _formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          //value = formatWithDelimiters(cents, 2);
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get("shipping-notice-v2") == "undefined") {
    customElements.define("shipping-notice-v2", ShippingNoticeV2);
  }
}
